import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppButton from "component/button/AppButton";
import SecondaryAuthLayout from "component/secondaryAuthLayout/SecondaryAuthLayout";
import styles from "./CreateNewPassword.module.css";
import TextField from "component/textField/TextField";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createNewPasswordSchema } from "schemas/auth/AuthSchemas";
import eye_slash from "assets/images/eye-slash.svg";
import eye from "assets/images/eye.svg";
import { useCreateNewPassword } from "api/mutations/auth/ForgotPassword";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";

function CreateNewPassword() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(createNewPasswordSchema) });
  const [passwordToggler, setPasswordToggler] = useState(true);
  const { loading, openModal, setOpenModal, createNewPasssword, setEmail } =
    useCreateNewPassword();

  useEffect(() => {
    setEmail(state.email);
  }, []);

  const handleSubmitPassord = (data) => {
    const payload = {
      ...state,
      password: data?.password,
    };

    createNewPasssword(payload);
  };

  const handleGoToLogin = () => {
    navigate("/");
  };

  return (
    <SecondaryAuthLayout>
      <div className={styles.reset_code}>
        <div className={styles.heading}>
          <Typography variant="h1">Create New Password</Typography>
          <Typography>Input your new password</Typography>
        </div>
        <div className={styles.form}>
          <div className={styles.field}>
            <TextField
              handleAction={() => {
                setPasswordToggler(!passwordToggler);
              }}
              errors={errors}
              name="password"
              register={register}
              required={true}
              type={passwordToggler ? "password" : "text"}
              label="New Password"
              icon={passwordToggler ? eye_slash : eye}
              placeholder="Insert Password"
            />
          </div>
          <div className={styles.field}>
            <TextField
              handleAction={() => {
                setPasswordToggler(!passwordToggler);
              }}
              errors={errors}
              name="confirm_password"
              register={register}
              required={true}
              type={passwordToggler ? "password" : "text"}
              label="Confirm New Password"
              icon={passwordToggler ? eye_slash : eye}
              placeholder="Insert Password"
            />
          </div>

          {/* <div className={styles.resend}>
            <Typography>
              Didnt receive any code ? <Link>Resend</Link>
            </Typography>
          </div> */}
          <div className={styles.form_btn}>
            <AppButton
              fullwidth
              textColor="#FFFFFF"
              btnBg="#0089FF"
              btnText="Submit"
              handleAction={handleSubmit(handleSubmitPassord)}
              loading={loading}
            />
          </div>
        </div>
      </div>

      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
              handleGoToLogin();
            }}
            btnText={"Proceed to Login"}
            icon={"success"}
            primaryText="Success"
            secondaryText="You have successfully reset your passowrd"
          />
        }
      />
    </SecondaryAuthLayout>
  );
}

export default CreateNewPassword;
